/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientTownHall } from '../models/ClientTownHall';
import type { PaginatedClientTownHallList } from '../models/PaginatedClientTownHallList';
import type { PatchedClientTownHall } from '../models/PatchedClientTownHall';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsTownHallsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedClientTownHallList
     * @throws ApiError
     */
    public clientsTownHallsList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedClientTownHallList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-town-halls/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ClientTownHall
     * @throws ApiError
     */
    public clientsTownHallsCreate({
        requestBody,
    }: {
        requestBody: ClientTownHall,
    }): CancelablePromise<ClientTownHall> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-town-halls/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ClientTownHall
     * @throws ApiError
     */
    public clientsTownHallsRetrieve({
        client,
    }: {
        /**
         * A unique value identifying this client town hall.
         */
        client: number,
    }): CancelablePromise<ClientTownHall> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-town-halls/{client}/',
            path: {
                'client': client,
            },
        });
    }

    /**
     * @returns ClientTownHall
     * @throws ApiError
     */
    public clientsTownHallsUpdate({
        client,
        requestBody,
    }: {
        /**
         * A unique value identifying this client town hall.
         */
        client: number,
        requestBody: ClientTownHall,
    }): CancelablePromise<ClientTownHall> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-town-halls/{client}/',
            path: {
                'client': client,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ClientTownHall
     * @throws ApiError
     */
    public clientsTownHallsPartialUpdate({
        client,
        requestBody,
    }: {
        /**
         * A unique value identifying this client town hall.
         */
        client: number,
        requestBody?: PatchedClientTownHall,
    }): CancelablePromise<ClientTownHall> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-town-halls/{client}/',
            path: {
                'client': client,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsTownHallsDestroy({
        client,
    }: {
        /**
         * A unique value identifying this client town hall.
         */
        client: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-town-halls/{client}/',
            path: {
                'client': client,
            },
        });
    }

}
